import { useEffect, useState } from 'react';
import { IPreparedLogs } from 'interfaces';
import api from 'api';
import classes from './DocumentsResearch.module.scss';
import LogsTable from 'components/LogsTable/LogsTable';
import prepareLogs from 'helpers/prepareLogs';
import { useTranslation } from 'react-i18next';

type Props = {
  document_id: string;
};

export default function DocumentActions({ document_id }: Props) {
  const [documentLogs, setDocumentLogs] = useState<IPreparedLogs[]>([]);
  const [isLaodingLogs, setIsLoadingLogs] = useState(false);

  const { i18n } = useTranslation();
  const locale = i18n.language || 'en';

  useEffect(() => {
    setIsLoadingLogs(true);
    const localization = locale === 'es' ? 'en' : locale;

    api
      .getDocumentLogs({ document_id, locale: localization })
      .then((response) => {
        setDocumentLogs(prepareLogs(response.data));
      })
      .catch((err) => {})
      .finally(() => setIsLoadingLogs(false));
  }, [locale]);

  return (
    <div className={classes.action}>
      <LogsTable
        logs={documentLogs}
        height='calc(100dvh - 219px)'
        scroll={{ y: 'calc(100dvh - 285px)' }}
        isLoading={isLaodingLogs}
      />
    </div>
  );
}
